<script setup lang="ts">import { computed as _computed } from 'vue';

import SButton from '@/components/SButton/SButton.vue';

interface SNavigationDrawerProps {
  /**
   * Whether the navigation drawer is open or not.
   */
  isOpen: boolean;
  /**
   * Title of the navigation drawer.
   */
  title?: string;
}
const props = defineProps({
  isOpen: { type: Boolean },
  title: { default: '' }
});

interface SNavigationDrawerEmits {
  (event: 'close-drawer'): void;
}
const emits = defineEmits(["close-drawer"]);

const isDrawerOpen = _computed(() => props.isOpen);
const drawerTitle = _computed(() => props.title);

const closeDrawer = () => {
  emits('close-drawer');
};

const handleDrawerInput = (val: boolean) => {
  if (!val) {
    closeDrawer();
  }
};
</script>

<template lang="pug">
v-navigation-drawer(
  v-bind="$attrs"
  v-on="$listeners"
  :value='isDrawerOpen'
  app temporary right width="600"
  @keydown.esc="closeDrawer()"
  @input="handleDrawerInput"
  style="overflow-y: scroll; z-index:205")

  v-container.drawer-container.pa-6( fluid )
    v-row
      v-col
        .d-flex.align-center.title-container( style="width: 100%; position: relative;" )
          .title-content
            .text-h5.font-weight-bold.text-truncate.mr-auto(v-if="drawerTitle") {{ drawerTitle }}
            slot(name="title")
          SButton(variant="text" color="secondary" @click="closeDrawer" icon="$close" class="close-btn")

    v-row
      v-col
        slot(name="content")

  .d-flex.drawer-bottom.pa-6.justify-end
    SButton(:text="$t('common.words.close')" @click="closeDrawer" )

</template>

<style lang="scss" scoped>
.drawer-container {
  height: calc(100vh - 84px);
  overflow-y: scroll;
  overflow-x: hidden;
  padding: 0;
  box-sizing: border-box;
}

.drawer-bottom {
  height: 84px;
  position: fixed;
  bottom: 0;
  width: 100%;
  box-sizing: border-box;
  background-color: var(--v-bgPrimary-base);
}

.title-container {
  min-height: 40px;
  position: relative;
}

.title-content {
  flex: 1;
  margin-right: 48px;
}

.close-btn {
  position: absolute;
  right: 0;
  top: 0;
  transform: none;
}
</style>
